export default __webpack_public_path__ + "static/media/AI Concierge.465526e6.svg";